import * as React              from 'react';

import { LabeledContent      } from 'src/components/common/labeled-content';
import { Typography          } from 'src/components/common/typography';

import { Container,
         TwoColumnRow,
         StatusInfoVariants,
         statusinfo_variants } from 'src/components/features/qmmsg/detail/status-info/ui';

import { QMMsg               } from 'src/services/api/types/qmmsg';

import { Nullable            } from 'src/common';



type Props = {
  variant: StatusInfoVariants;
  claim: QMMsg;
  timestampExecution: Nullable<number>;
  weight: string;
  type: string;
}
export const StatusInfo: React.FC<Props> = ({
  variant,
  claim,
  timestampExecution,
  weight,
  type,
}) => {
  const lookAndFeel = statusinfo_variants.get(variant)!;

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <Typography variant = 'blackw400s14lh18'>
        { `${claim?.signMsg === 'complaint' ? 'Претензия' : 'Уведомление'} №${claim?.qmMsgNumber ?? ''}` }
      </Typography>
      <TwoColumnRow lookAndFeel = { lookAndFeel }>
        <LabeledContent variant = { lookAndFeel.labeledContentVariant } label = 'Дата регистрации'>
          <Typography variant = 'blackw400s14lh18'>
            { timestampExecution === null ? 'не присвоено' : new Date(timestampExecution).toLocaleDateString() }
          </Typography>
        </LabeledContent>
        <LabeledContent variant = { lookAndFeel.labeledContentVariant } label = 'Тип обращения'>
          <Typography variant = 'blackw400s14lh18'>
            { type }
          </Typography>
        </LabeledContent>
      </TwoColumnRow>
      <LabeledContent variant = { lookAndFeel.labeledContentVariant } label = 'Кол-во брака'>
        <Typography variant = 'blackw400s14lh18'>
          { weight }
        </Typography>
      </LabeledContent>
    </Container>
  );
};
